import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.7433 5.6732c.4087-.3715 1.0412-.3414 1.4127.0672l5 5.5a1 1 0 0 1-.0329 1.3798l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l4.3258-4.3258-4.3586-4.7944c-.3715-.4087-.3414-1.0411.0672-1.4127",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M3.569 4.3107a1 1 0 0 0-.9479.908l-.617 6.7615c-.027.2956.0789.588.2888.798l6.8272 6.8272c.3906.3905 1.0237.3905 1.4143 0l7.071-7.0711c.3906-.3905.3906-1.0237 0-1.4142l-6.8272-6.8272a1 1 0 0 0-.755-.2918zm6.2582 13.1734-5.7887-5.7888.4953-5.4286 5.1431-.2466 5.8072 5.8071zm-1.166-8.068c.5505-.044 1.0325.3665 1.0766.917s-.3664 1.0325-.917 1.0766-1.0325-.3664-1.0766-.917c-.044-.5505.3665-1.0325.917-1.0766m-.1597-1.9936c1.6516-.1323 3.0977 1.0993 3.23 2.7509s-1.0994 3.0976-2.751 3.2299-3.0976-1.0993-3.2299-2.7509 1.0993-3.0976 2.751-3.23",
        clipRule: "evenodd"
    }, "1")
], "AudienceSegmented", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
